/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import { FontFamily, FontSize, FontWeight } from 'yospace-ui-components';

export class ManageAssetPoolsPageStyles {
    static STYLES = Object.freeze({
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        contentContainer: {
            padding: '27px 0px 0px 0px'
        },
        title: {
            fontFamily: FontFamily.variable,
            fontSize: FontSize.large2,
            fontWeight: FontWeight.titleBold,
            padding: '26px 0px 17px 4px'
        },
        topPanelContainer: {
            padding: '0px 0px 0px 34px'
        }
    });

    static getButtonsContainer() {
        return ManageAssetPoolsPageStyles.STYLES.buttonsContainer;
    }

    static getContentContainer() {
        return ManageAssetPoolsPageStyles.STYLES.contentContainer;
    }

    static getTitle() {
        return ManageAssetPoolsPageStyles.STYLES.title;
    }

    static getTopPanelContainer() {
        return ManageAssetPoolsPageStyles.STYLES.topPanelContainer;
    }
}
